import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Pagination, Spin, Button, Tooltip } from 'antd';
import { BulkHistory as BulkHistoryIcon } from 'common/components/svgs';
import authControl from '~components/auth-control';
import { communicationStatus, platformEntity, entityAction } from '~constants';
import * as reconciliationActions from '~actions/reconciliation';
import BulkUpdate from '~pages/dashboard/reconciliation/bulk-update';
import BulkHistory from '~pages/dashboard/reconciliation/bulk-history';
import { downloadExcelFile } from '~pages/dashboard/reconciliation/utils';
import ReconciliationTable from '~pages/dashboard/reconciliation/table';
import ReconciliationFilter from '@pages/dashboard/reconciliation/consultant-reconciliation-filter';
import ExportData from './export-data';

const mapStateToProps = state => ({
  totalCount: state.dashboard.reconciliation?.toJS().listOpportunityReconciliationList.totalCount,
  status:
    state.dashboard.reconciliation?.toJS().communication?.listOpportunityReconciliationList?.status,
  communication: state.dashboard.reconciliation.get('communication')?.toJS(),
  list: state.dashboard.reconciliation?.toJS().listOpportunityReconciliationList,
});

const mapDispatchToProps = dispatch => ({
  listOpportunityReconciliation: params => {
    dispatch(reconciliationActions.listOpportunityReconciliation(params));
  },
});
@connect(mapStateToProps, mapDispatchToProps)
@withTranslation()
@authControl(platformEntity.BOOKINGS_OPPORTUNITIES, entityAction.READ)
export default class Reconciliation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      filters: {
        pageSize: 20,
        pageNumber: 1,
      },
      showBulkUpdate: false,
      showBulkHistory: false,
      visible: false,
    };
  }

  componentDidMount() {
    this.handleSetFilters();
  }

  onShowSizeChange = (current, pageSize) => {
    this.handleSetFilters({
      pageSize: Number(pageSize),
      pageNumber: 1,
    });
  };

  onPageNumberChange = pageNumber => {
    this.handleSetFilters({ pageNumber: Number(pageNumber) });
  };

  handleSetFilters = filters => {
    const newfilters = Object.assign({}, this.state.filters, filters);
    this.setState({ filters: newfilters }, () => {
      this.handleReloadListReconciliationLandlords();
    });
  };

  handleReloadListReconciliationLandlords = () => {
    this.props.listOpportunityReconciliation(this.state.filters);
  };

  handleBulkUpdate = () => {
    this.setState({ showBulkUpdate: true });
  };

  handleCloseBulkUpdate = () => {
    this.setState({ showBulkUpdate: false });
  };

  handleDownloadTemplate = () => {
    const DEFAULT_TEMPLATE_FILENAME = 'Bookings bulk update template final.xlsx';
    downloadExcelFile(DEFAULT_TEMPLATE_FILENAME);
  };

  handleBulkHistory = () => {
    this.setState({ showBulkHistory: true });
  };

  handleCloseBulkHistory = () => {
    this.setState({ showBulkHistory: false });
  };

  render() {
    const { t, status, totalCount, list } = this.props;

    return (
      <div className="reconciliation">
        <div className="reconciliation__container">
          <div className="reconciliation__header">
            <h1 className="reconciliation__title">{t('cms.reconciliation.list.title')}</h1>
            <div className="reconciliation__btn-wrap">
              <Tooltip
                placement="topLeft"
                title={t('cms.reconciliation.tooltip.bulk_update_history')}
                arrowPointAtCenter
              >
                <Button
                  className="reconciliation__icon-btn reconciliation__icon-btn--history reconciliation-header-btn"
                  onClick={this.handleBulkHistory}
                >
                  <BulkHistoryIcon className="reconciliation__icon-btn__icon" />
                </Button>
              </Tooltip>
              {/* <Tooltip
                placement="topLeft"
                title={t('cms.reconciliation.tooltip.download_template')}
                arrowPointAtCenter
              > */}
              <Button
                className="reconciliation__icon-btn reconciliation__icon-btn--download reconciliation-header-btn"
                onClick={this.handleDownloadTemplate}
              >
                {/* <TemplateDownloadIcon className="reconciliation__icon-btn__icon" /> */}
                {t('cms.reconciliation.tooltip.download_template')}
              </Button>
              {/* </Tooltip> */}
              <Button
                className="reconciliation__bulk-update-btn"
                type="primary"
                onClick={this.handleBulkUpdate}
              >
                {t('cms.reconciliation.booking.bulk_update.button')}
              </Button>
            </div>
          </div>

          <ReconciliationFilter
            handleQueryList={params => {
              this.setState(
                {
                  filters: {
                    ...params,
                    pageSize: 20,
                    pageNumber: 1,
                  },
                },
                () => {
                  this.props.listOpportunityReconciliation({
                    ...this.state.filters,
                  });
                },
              );
            }}
          />
          <Spin spinning={status === communicationStatus.FETCHING}>
            <div className="reconciliation__body">
              <div className="reconciliation__total-line">
                <label className="reconciliation__total-count">{`Total ${totalCount} results`}</label>
                <Button
                  className="reconciliation__export"
                  icon="export"
                  type="link"
                  loading={false}
                  onClick={() => {
                    this.setState({ visible: true });
                  }}
                >
                  {t('cms.reconciliation.landlord.export.export')}
                </Button>
              </div>

              <ReconciliationTable list={list} />
            </div>

            <div className="reconciliation__footer">
              <Pagination
                showSizeChanger
                onShowSizeChange={this.onShowSizeChange}
                pageSizeOptions={['10', '20', '30', '40']}
                total={totalCount}
                pageSize={Number(this.state.filters.pageSize)}
                current={Number(this.state.filters.pageNumber)}
                onChange={this.onPageNumberChange}
              />
            </div>
          </Spin>
        </div>
        <If condition={this.state.showBulkUpdate}>
          <BulkUpdate
            cancel={this.handleCloseBulkUpdate}
            openBulkHistory={this.handleBulkHistory}
          />
        </If>
        <If condition={this.state.showBulkHistory}>
          <BulkHistory cancel={this.handleCloseBulkHistory} />
        </If>
        {this.state.visible && (
          <ExportData
            t={t}
            total={totalCount}
            visible={this.state.visible}
            queryFilter={this.state.filters}
            onClose={() => this.setState({ visible: false })}
          />
        )}
      </div>
    );
  }
}

Reconciliation.propTypes = {
  t: PropTypes.func.isRequired,
  status: PropTypes.string,
  totalCount: PropTypes.number,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  listOpportunityReconciliation: PropTypes.func,
};

Reconciliation.defaultProps = {
  t: () => {},
  listOpportunityReconciliation: () => {},
  status: '',
  totalCount: 0,
};
